// #ux-redesign-start: Dashboard rediseñada (Patients) — versión compacta mobile.
// Launchers a las 4 áreas principales (Termine, Inbox, Labor, Profil) usando
// clases CSS reales (no inline styles), para que el SCSS pueda compactar en
// breakpoints. 90% del tráfico es mobile.
//
// Grid responsive:
//   - xs (<576px):   2 col compactas, 110px min-height, icono 36px
//   - sm (≥576):     2 col, 140px min-height
//   - md (≥768):     2 col, 180px min-height
//   - lg (≥992):     4 col
// ─────────────────────────────────────────────────────────────────────────────

import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslate } from "react-translate";
import history from "historyRouter";

import { PageContainer, Card, Badge } from "components/ds";

const Launcher = ({ to, icon, label, badge }) => (
  <Card
    interactive
    className="ds-launcher"
    onClick={() => history.push(to)}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        history.push(to);
      }
    }}
  >
    <div className="ds-launcher__body">
      {badge > 0 && (
        <span className="ds-launcher__badge">
          <Badge variant="priority" size="md">
            {badge > 99 ? "99+" : badge}
          </Badge>
        </span>
      )}
      <span className={`ds-launcher__icon ${icon}`} aria-hidden="true" />
      <span className="ds-launcher__label">{label}</span>
    </div>
  </Card>
);

const Dashboard = () => {
  const tSidebar = useTranslate("sidebar");
  const tLaboratory = useTranslate("laboratory-studies");
  const tProfile = useTranslate("profile");
  const tInbox = useTranslate("messages");

  const laboratoryNotifications = useSelector(
    (state) => state.notificationsReducer["laboratory"]
  );
  const messageNotifications = useSelector(
    (state) => state.notificationsReducer["messages"]
  );

  const launchers = [
    {
      to: "/admin/frametest",
      icon: "icon-appointments",
      label: tSidebar("iframe"),
      badge: 0,
    },
    {
      to: "/admin/inbox",
      icon: "icon-inbox-header",
      label: tInbox("title"),
      badge: messageNotifications?.unreaded || 0,
    },
    {
      to: "/admin/lab-studies",
      icon: "icon-microscope",
      label: tLaboratory("laboratory-studies"),
      badge: laboratoryNotifications?.unreaded || 0,
    },
    {
      to: "/admin/profile",
      icon: "icon-user-active",
      label: tProfile("title"),
      badge: 0,
    },
  ];

  return (
    <Fragment>
      <PageContainer
        title={tSidebar("dashboard")}
        icon="d"
      >
        <div className="ds-dashboard-grid">
          {launchers.map((l) => (
            <Launcher key={l.to} {...l} />
          ))}
        </div>
      </PageContainer>
    </Fragment>
  );
};

export default Dashboard;
// #ux-redesign-end
